export const EXPERIMENTS: Record<string, string> = {
  EMAIL_VALIDATION: 'ab_test_email_validation',
  FRESH_CHAT: 'fresh-chat',
};

export const EXPERIMENTS_TO_USER_PROPS_MAP = {
  [EXPERIMENTS.EMAIL_VALIDATION]: 'ab_test_email_validation',
};

export enum EXPERIMENTS_ENUM {
  EMAIL_VALIDATION = 'ab_test_email_validation',
  FRESH_CHAT = 'fresh-chat',
}

export enum EXPERIMENTS_TO_USER_PROPS_MAP_ENUM {
  EMAIL_VALIDATION = 'ab_test_email_validation',
}
